import { useMutation } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { apiMethodsConst } from '~/services/methods';
import { PhoneVerificationService } from '../services/PhoneVerificationService';
import type { IVerifyMfaCodeRequest } from '../types/PhoneVerification';

interface IReduxUser {
  id?: string;
  contact_number?: string | null;
  [key: string]: unknown;
}

export const useVerifyMfaCode = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(
    (state: { user?: { user?: IReduxUser | null } }) => state.user?.user ?? null,
  );

  return useMutation<void, unknown, IVerifyMfaCodeRequest>({
    mutationFn: (payload) => PhoneVerificationService.verifyMfaCode(payload),
    onSuccess: (_data, { phone }) => {
      if (!currentUser?.id) return;
      // EDIT_USER_REQUEST replaces the user slice when ids match — spread current
      // user so we only update contact_number without dropping other fields.
      dispatch({
        type: apiMethodsConst.EDIT_USER_REQUEST,
        payload: { ...currentUser, contact_number: phone },
      });
    },
  });
};
